// wp-icons — System & Device (8)
// Home, Settings leben in craft.js.
import { createWpIcon } from './createIcon.js';

export const LogIn = createWpIcon('LogIn', [
  ['path', { d: 'M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4', key: 'a' }],
  ['polyline', { points: '10 17 15 12 10 7', key: 'b' }],
  ['line', { x1: 15, x2: 3, y1: 12, y2: 12, key: 'c' }],
]);
export const LogOut = createWpIcon('LogOut', [
  ['path', { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', key: 'a' }],
  ['polyline', { points: '16 17 21 12 16 7', key: 'b' }],
  ['line', { x1: 21, x2: 9, y1: 12, y2: 12, key: 'c' }],
]);
export const Power = createWpIcon('Power', [
  ['path', { d: 'M12 2v10', key: 'a' }],
  ['path', { d: 'M18.4 6.6a9 9 0 1 1-12.77.04', key: 'b' }],
]);
export const Smartphone = createWpIcon('Smartphone', [
  ['rect', { width: 14, height: 20, x: 5, y: 2, rx: 2, ry: 2, key: 'a' }],
  ['path', { d: 'M12 18h.01', key: 'b' }],
]);
export const Wifi = createWpIcon('Wifi', [
  ['path', { d: 'M5 13a10 10 0 0 1 14 0', key: 'a' }],
  ['path', { d: 'M8.5 16.5a5 5 0 0 1 7 0', key: 'b' }],
  ['path', { d: 'M2 8.82a15 15 0 0 1 20 0', key: 'c' }],
  ['line', { x1: 12, x2: 12.01, y1: 20, y2: 20, key: 'd' }],
]);
export const WifiOff = createWpIcon('WifiOff', [
  ['line', { x1: 2, x2: 22, y1: 2, y2: 22, key: 'a' }],
  ['path', { d: 'M8.5 16.5a5 5 0 0 1 7 0', key: 'b' }],
  ['path', { d: 'M2 8.82a15 15 0 0 1 4.17-2.65', key: 'c' }],
  ['path', { d: 'M10.66 5c4.01-.36 8.14.9 11.34 3.76', key: 'd' }],
  ['path', { d: 'M16.85 11.25a10 10 0 0 1 2.22 1.68', key: 'e' }],
  ['path', { d: 'M5 13a10 10 0 0 1 5.24-2.76', key: 'f' }],
  ['line', { x1: 12, x2: 12.01, y1: 20, y2: 20, key: 'g' }],
]);
export const CloudOff = createWpIcon('CloudOff', [
  ['path', { d: 'm2 2 20 20', key: 'a' }],
  ['path', { d: 'M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193', key: 'b' }],
  ['path', { d: 'M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07', key: 'c' }],
]);
export const Globe = createWpIcon('Globe', [
  ['circle', { cx: 12, cy: 12, r: 10, key: 'a' }],
  ['path', { d: 'M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20', key: 'b' }],
  ['path', { d: 'M2 12h20', key: 'c' }],
]);
